import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { Spacing } from '~/types/ThemeTypes'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const defaultColors = themeColorSectionKeys.defaults
const { TagInput } = themeColorSectionKeys.shared

const tagInputStyleParts = [
  'dataContainer',
  'inputContainer',
  'tagContainer',
  'tag',
  'tagCloseButton',
  'errorContainer',
  'guideText',
  'errorText',
] as const

const helpers = createMultiStyleConfigHelpers(tagInputStyleParts)
export const TagInputStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    dataContainer: {
      alignItems: 'stretch',
      gap: Spacing._4,
    },
    tagContainer: {
      flexWrap: 'wrap',
    },
    inputContainer: {
      alignItems: 'stretch',
      gap: Spacing._1,
    },
    tagCloseButton: {
      color: TagInput.Icon,
    },
    errorContainer: {
      alignItems: 'stretch',
      gap: Spacing._0_5,
    },
    guideText: {
      textStyle: textStyleKeys.Body4,
      color: defaultColors.FontColor.Default,
    },
    errorText: {
      color: defaultColors.FontColor.Error,
      textStyle: textStyleKeys.Body3_Bold,
    },
  },
})

const themeKey = getName({ TagInputStyle })
export const useTagInputStyles = () =>
  useCustomMultiStyleConfig<typeof tagInputStyleParts>(themeKey)
export const useTagInputStyleConfig = () =>
  createCustomStyleContext<typeof tagInputStyleParts>(themeKey)
